import diff from "../diff";
import serializeAttachment from "./serializeAttachment";

export default function serializeCompany(data, initialData) {
  return {
    ...data,
    translations_attributes: data.translations,
    translations: undefined,
    logo_image_attributes: data.logo_image && serializeAttachment(data.logo_image),
    logo_image: undefined,
    marketplace_cover_image_attributes:
      data.marketplace_cover_image && serializeAttachment(data.marketplace_cover_image),
    marketplace_cover_image: undefined,
    saas_cover_image_attributes: data.saas_cover_image && serializeAttachment(data.saas_cover_image),
    saas_cover_image: undefined,
    company_payment_profile_relations_attributes: data.company_payment_profile_relations,
    company_payment_profile_relations: undefined,
  };
}



// WEBPACK FOOTER //
// ./src/lib/utils/api/serializers/serializeCompany.js